import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AdminShell } from "../chrome/AdminShell";
import { useAuth } from "@/lib/auth-context";

const pageFallback = (
  <div style={{ padding: 40, color: "var(--on-surface-variant)" }}>
    Se încarcă…
  </div>
);

// Admin route group gate. Mirrors AppShellWithGuard but adds the admin-claim
// check. Crucially it waits on `claimsLoading` before deciding to redirect —
// redirecting while the claim is still resolving would bounce a real admin.
// Non-admins are sent to /masini (silent redirect, matching the repo's
// redirect-over-404 convention); client `isAdmin` is UX-only — the backend
// `assertAdmin` gate is the real protection.
export function AdminShellWithGuard() {
  const { user, loading, claimsLoading, isAdmin } = useAuth();

  if (loading || claimsLoading) {
    return (
      <div style={{ padding: 40, color: "var(--on-surface-variant)" }}>
        Se încarcă…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/cont/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/masini" replace />;
  }

  return (
    <AdminShell>
      <Suspense fallback={pageFallback}>
        <Outlet />
      </Suspense>
    </AdminShell>
  );
}
